module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "poiService.36d46062.png";